module.exports = __webpack_public_path__ + "static/img/solutionPic5.cfe0781.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionPic5.png
// module id = 4qok
// module chunks = 1